export function formatINR(n) {
    const num = Number(n || 0);
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 2,
    }).format(num);
}

export function statusStyle(status) {
    const map = {
        active: "bg-emerald-100 text-emerald-800 border-emerald-200",
        registered: "bg-slate-100 text-slate-700 border-slate-200",
        suspended: "bg-red-100 text-red-800 border-red-200",
        pending: "bg-blue-50 text-blue-700 border-blue-200",
        approved: "bg-emerald-100 text-emerald-800 border-emerald-200",
        rejected: "bg-red-100 text-red-800 border-red-200",
        not_submitted: "bg-slate-100 text-slate-700 border-slate-200",
        paid: "bg-emerald-100 text-emerald-800 border-emerald-200",
        created: "bg-slate-100 text-slate-700 border-slate-200",
        failed: "bg-red-100 text-red-800 border-red-200",
        credited: "bg-emerald-100 text-emerald-800 border-emerald-200",
        skipped: "bg-slate-100 text-slate-700 border-slate-200",
        success: "bg-emerald-100 text-emerald-800 border-emerald-200",
        running: "bg-blue-50 text-blue-700 border-blue-200",
    };
    return map[status] || "bg-slate-100 text-slate-700 border-slate-200";
}
